import * as utils from '@libs/utils'

/**
 * 画像圧縮
 * @param {dataURL} img 
 * @param isNotDate 本日日付を写真に描画しない（基本は描画）
 * @param {*} maxSize リサイズ後の最大幅
 * @param compresseRate 圧縮率（1.0：無劣化/サイズ大、0.9：ほぼ無劣化/少し小さくなる、0.8：ほとんど無劣化/かなり小さくなる）
 */
  export function compressImage(img, isNotDate, maxSize, compresseRate) {
  // 画像のサイズを変更するためにリサイズ処理
  let width = img.width
  let height = img.height

  // リサイズ後の最大幅が指定の場合
  if (maxSize && (width > maxSize || height > maxSize) ) {
    const ratio = Math.min(
      maxSize / width,
      maxSize / height
    )
    width = Math.round(width * ratio)
    height = Math.round(height * ratio)
  }
  // 新しいキャンバスを作成
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height

  // キャンバスに描画するためのコンテキストを取得
  const ctx = canvas.getContext('2d')
  // 画像をキャンバスに描画せずに直接リサイズ
  ctx.drawImage(img, 0, 0, width, height)
  // 写真撮影日時を写真に描画
  if (!isNotDate) {
    utils.setDateToImg(null, canvas, ctx, false)
  }
  // キャンバスの画像を再度DataURLに変換して圧縮率を下げる
  const compressedDataUrl = canvas.toDataURL('image/jpeg', (compresseRate || 1.0)) // （推奨）0.8だとサイズは小さくなるが見た目はほぼ変わらない

  return compressedDataUrl
}

/**
 * bufferをimgタグで表示できる形（Base64）に変換
 * @param {*} data { buffer, mimeType }
 * @returns dataUrl
 */
export function bufferToDataUrl (data) {
  if (data && data.buffer) {  
    const buffer = data.buffer.data
    const mimeType = data.mimeType

    // bufferをbase64に変換
    const base64 = utils.arrayBufferToBase64(buffer)
    // imgタグで表示できる形に変換
    const dataUrl = `data:${mimeType};base64,${base64}`
    return dataUrl
  }
  return null
}